import {TrendAmount} from './trend-amount';
import {Indicator} from '../services/api/fit-api/models/indicators/indicator';
import {SeriesType} from "./default-trend-chart-options";

// note: options are used as optional route param names
export enum FinancialHealthSeriesOption {
	displayIndicatorNet = 'displayIndicatorNet',
	displayIndicatorBenchmark = 'displayIndicatorBenchmark',
	displayGovTypeMean = 'displayGovTypeMean',
	displayGovTypeMedian = 'displayGovTypeMedian',
	displayGovTypeTrimean = 'displayGovTypeTrimean'
}

export class FinancialHealthSeries {
	constructor(
		public option: FinancialHealthSeriesOption | undefined,
		public type: SeriesType = 'line',
		public name: string,
		public color: string,
		public hex: string,
		public yAxisId: string,
		public trendAmounts: (indicator: Indicator) => TrendAmount[],
		public pointStyle: string | false,
		public borderDash?: number[],
	) {
	}
}
